import RadioButton from 'flow/components/ui-components/RadioButton';
import useAppContext from 'flow/hooks/useAppContext';
import useProfiles from 'flow/hooks/useProfiles';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { Profile } from 'flow/types/Profile';
import { TypedMap } from 'flow/types/TypedMap';
import React, { MouseEventHandler } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useParams } from 'react-router-dom';
import Page from '../../Page';
import SettingSection from '../../SettingSection';
import onUpdate from '../functions/onUpdate';

interface Props {
    profile: TypedMap<Profile>;
    onClickBack: MouseEventHandler;
}

interface Params {
    profileKey: ProfileKey | 'profile';
    extensionKey: ExtensionKey;
}

const Mobile = ({ profile, onClickBack }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { profileKey, extensionKey } = useParams<Params>();
    const { profiles } = useProfiles(extensionKey);
    const letThroughMexCalls = profile.getIn([
        'parallelCalls',
        'letThroughMexCalls',
    ]);

    return (
        <Page onClickBack={onClickBack} header="settings.incoming_calls.mex">
            <SettingSection>{i18next.t('settings.title.logic')}</SettingSection>

            <RadioButton
                name="mexCalls"
                checked={letThroughMexCalls}
                onChange={() =>
                    dispatch(
                        onUpdate(
                            extensionKey,
                            profileKey,
                            [
                                {
                                    state: [
                                        'parallelCalls',
                                        'letThroughMexCalls',
                                    ],
                                    value: true,
                                },
                                {
                                    state: [
                                        'parallelCalls',
                                        'parallelCallType',
                                    ],
                                    value: profile.getIn([
                                        'parallelCalls',
                                        'parallelCallType',
                                    ]),
                                },
                            ],
                            profiles,
                        ),
                    )
                }
            >
                {i18next.t('settings.incoming_calls.optionlist.mex.on')}
            </RadioButton>
            <RadioButton
                name="mexCalls"
                checked={!letThroughMexCalls}
                onChange={() =>
                    dispatch(
                        onUpdate(
                            extensionKey,
                            profileKey,
                            [
                                {
                                    state: [
                                        'parallelCalls',
                                        'letThroughMexCalls',
                                    ],
                                    value: false,
                                },
                                {
                                    state: [
                                        'parallelCalls',
                                        'parallelCallType',
                                    ],
                                    value: profile.getIn([
                                        'parallelCalls',
                                        'parallelCallType',
                                    ]),
                                },
                            ],
                            profiles,
                        ),
                    )
                }
            >
                {i18next.t('settings.incoming_calls.optionlist.mex.off')}
            </RadioButton>
        </Page>
    );
};

export default Mobile;
